import { ref, onMounted, onUnmounted, toRaw,  computed, } from 'vue'
// * STOREs

import { usePatientStore } from "@/stores/patientStore";

import { useStoreWorkList } from "@/stores/workListsStore";

export function discreteDataDashMixin(data) {
    const props1 = ref(data)
      // // console.log('props1')
      // // console.log(props1)

  const patientStore = usePatientStore();
  const workListStore = useStoreWorkList();

// *Trans For COMPUTED function

// * a computed ref
const currentlySelectedRecords = computed(() => {
          // // console.log('   currentlySelectedRecords >>>> discreteDataDASH mixn     dDAPI:  props.sourceId: ', props.sourceId)

        const taskRecSource = workListStore.getDashTaskRecordsForSource(workListStore.currentSelectedWorkSummaryWidget.sourceId).map(record => record.id)
        // // console.log(' Get taskRecords by Source of :', props.sourceId)
        // // console.log('      * ARRAY of IDs (selectedFromRow) *                 taskRecSource :', taskRecSource.length)
        // // console.log('                                         SOURCE CHECK:  rtns  record.id=      taskRecSource :')
        // // console.log(taskRecSource)

        return workListStore.getDashTaskRecordsForSource(workListStore.currentSelectedWorkSummaryWidget.sourceId).map(record => record.id)
});


// ! Functions To TRANS
    function recordsSelectedWidgetWork(ids) {
        // // console.clear()
        // console.log('    WIDGET Record - DataMX recordSEle Handler: ', ids)

        // const dTask = this.allMyWork.filter((patient) => ids.includes(patient.personId))
        // // console.log('   dTask: ', dTask)
        // // console.log('  >>> PROPS from ROOT function  ')
        // // console.log(props)

        // let lSource = parseInt(this.currentSelectedWorkSummaryWidget.sourceId)

        // &  task / delg tasks   containerId: parseInt(included.personId),
        // & ELSE  task / delg tasks   containerId: parseInt(0),

        // // console.log(workListStore.currentSelectedWorkSummaryWidget)
        // // console.log(workListStore.currentSelectedWorkSummaryWidget.sourceId)
        // // console.log(workListStore.currentSelectedWorkSummaryWidget.sourceType)

        let sSourceId = 0
        let sSourceType = 'XXXX'
        // // console.log(sSourceId + ' ' + sSourceType)

        sSourceId = workListStore.currentSelectedWorkSummaryWidget.sourceId
        sSourceType = workListStore.currentSelectedWorkSummaryWidget.sourceType
        // // console.log(sSourceId + ' ' + sSourceType)

        const tasks = workListStore.currentSelectedWorkSummaryWidget.widgetGridDataArray.filter(patient => ids.includes(patient.personId)).map(included => ({
          type: sSourceType,
          description: included.lastName + ' ' + included.firstName,
          id: included.id,
          sourceId: sSourceId,
          containerId: parseInt(included.personId),
        }))
        // // console.log('   ***     ***     recordsSelectedDashHandler     ***     recordsSelectedWidgetWork     ***           DASH-   tasks', tasks)
        // // console.log(' >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  ** TODO:  this.addDashTaskRecords({ ')

        // // console.log(sSourceId)
        // // console.dir(tasks)


        workListStore.addDashTaskRecords({ sourceId: sSourceId, tasks })
      };

    function recordsSelectedWidgetOtherWork(ids) {
        // // console.clear()
        // // console.log('    WIDGET Record - DataMX recordSEle Handler: ', ids)

        // const dTask = this.allMyWork.filter((patient) => ids.includes(patient.personId))
        // // console.log('   dTask: ', dTask)
        // // console.log('  >>> PROPS from ROOT function  ')
        // // console.log(props)

        // let lSource = parseInt(this.currentSelectedWorkSummaryWidget.sourceId)

        // &  task / delg tasks   containerId: parseInt(included.personId),
        // & ELSE  task / delg tasks   containerId: parseInt(0),

        // console.log(workListStore.currentSelectedWorkSummaryWidget)
        // console.log(workListStore.currentSelectedWorkSummaryWidget.sourceId)
        // console.log(workListStore.currentSelectedWorkSummaryWidget.sourceType)

        let sSourceId = 0
        let sSourceType = 'XXXX'
        // console.log(sSourceId + ' ' + sSourceType)

        sSourceId = workListStore.currentSelectedWorkSummaryWidget.sourceId
        sSourceType = workListStore.currentSelectedWorkSummaryWidget.sourceType
        // console.log(sSourceId + ' ' + sSourceType)

        //const tasks = workListStore.currentSelectedWorkSummaryWidget.widgetGridDataArray.filter(patient => ids.includes(patient.personId)).map(included => ({

// ! org
      //  const tasks = workListStore.currentSelectedWorkSummaryWidget.widgetGridDataArray.filter(items => ids.includes(items.id)).map(included => ({

        const tasks = workListStore.currentSelectedWorkSummaryWidget.widgetGridDataArray.filter(patient => ids.includes(patient.personId)).map(included => ({
          type: sSourceType,
          description: included.messageSubject + ' : ' + included.taskType,
          id: included.id,
          sourceId: sSourceId,
            containerId: parseInt(included.personId),
        }))

        // console.log('   ***     ***     recordsSelectedDashHandler     ***     recordsSelectedWidgetWork     ***           DASH-   tasks', tasks)
        // console.log(' >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  ** TODO:  workListStore.addDashTaskRecords({ ')

        // console.log(sSourceId)
        // console.dir(tasks)


        workListStore.addDashTaskRecords({ sourceId: sSourceId, tasks })
      };





  // & THESE need   allMyWork / Friends

  //   function   recordsSelectedDashHandler(ids) {
  //       // console.log('    DASH- DataMX recordSEle Handler: ', ids)

  //       // const dTask = this.allMyWork.filter((patient) => ids.includes(patient.personId))
  //       // // console.log('   dTask: ', dTask)

  //       const tasks = this.allMyWork.filter(patient => ids.includes(patient.personId)).map(included => ({
  //         type: props.type,
  //         description: included.lastName + ' ' + included.firstName,
  //         id: included.id,
  //         sourceId: props.sourceId,
  //         containerId: parseInt(included.personId),
  //       }))
  //       // console.log('   ***     ***     recordsSelectedDashHandler     ***     ***     ***           DASH-   tasks', tasks)
  //       // // console.log('   ***     containerId: parseInt(inc.personId) ', tasks)
  //       // // console.log('   ** TODO:  id=8||4248 string  >>>>>>>>>>>>>>>>>>>>>>>>  DASH-   tasks', tasks)

  //       this.addDashTaskRecords({ sourceId: props.sourceId, tasks })
  //     },
  //   function   recordsSelectedDelegatedDashHandler(ids) {
  //       // // console.log('    DASH- DataMX recordSEle Handler: ', ids)

  //       // const dTask = this.allMyDelegatedWork.filter((patient) => ids.includes(patient.personId))
  //       // // console.log('  CHECK DELEGATED = dTask: ', dTask)

  //       const tasks = this.allMyDelegatedWork.filter(patient => ids.includes(patient.personId)).map(included => ({
  //         type: props.type,
  //         description: included.lastName + ' ' + included.firstName,
  //         id: included.id,
  //         sourceId: props.sourceId,
  //         containerId: parseInt(included.personId),
  //       }))
  //       // console.log('   ***     ***      recordsSelectedDelegatedDashHandler     ***     ***     ***           DASH-   tasks', tasks)
  //       // // console.log('   ***     containerId: parseInt(inc.personId) ', tasks)
  //       // // console.log('   ** TODO:  id=8||4248 string  >>>>>>>>>>>>>>>>>>>>>>>>  DASH-   tasks', tasks)

  //       this.addDashTaskRecords({ sourceId: props.sourceId, tasks })
  //     },
  //   function   recordsSelectedMyOtherHandler(ids) {
  //       // // console.log('    MyOTHER  work - DataMX recordSEle Handler: ', ids)
  //       // // console.log('BREAK >>  filter  this.myOtherWork XXX  by  id :')

  //       // const dTask = this.allMyOtherWork.filter((items) => ids.includes(items.id))
  //       // // console.log('  **********allMyOtherWork************************************************************  dTask: ', dTask)

  //       const tasks = this.allMyOtherWork.filter(items => ids.includes(items.id)).map(included => ({
  //         type: props.type,
  //         description: included.messageSubject + ' : ' + included.taskType,
  //         id: included.id,
  //         sourceId: props.sourceId,
  //         containerId: parseInt(0),
  //       }))
  //       // console.log('   ***     ***      recordsSelectedMyOtherHandler     ***     ***     ***           DASH-   tasks', tasks)
  //       // console.log('   ***     containerId: parseInt( 0 ) ', tasks[0].containerId)

  //       // console.log(' Add DASH TaskRECORDS')
  //       this.addDashTaskRecords({ sourceId: props.sourceId, tasks })
  //     },
  //   function   recordsSelectedMyASSIGNEDHandler(ids) {
  //       // // console.log('    My ASSIGNED  work - DataMX recordSEle Handler: ', ids)
  //       // // console.log('                   BREAK >>  filter  this.myAssignedWorkItems                      XXX  by  id :')

  //       // const dTask = this.allMyAssignedWork.filter((items) => ids.includes(items.id))
  //       // // console.log('  *** TEST   myAssignedWorkItems/                        *******************allMyAssignedWork ************************************************ TEST TEST TEST  dTask: ', dTask)

  //       const tasks = this.allMyAssignedWork.filter(items => ids.includes(items.id)).map(included => ({
  //         type: props.type,
  //         description: included.messageSubject + ' : ' + included.taskType,
  //         id: included.id,
  //         sourceId: props.sourceId,
  //         containerId: parseInt(0),
  //       }))
  //       // console.log('           DASH-  DataMXn  :  recordsSelectedMyASSIGNEDHandler    ***     ***           DASH-   tasks', tasks)
  //       // // console.log(' Add DASH TaskRECORDS - - - - ASSIGNED ')

  //       this.addDashTaskRecords({ sourceId: props.sourceId, tasks })
  //     },
  //   function   recordsSelectedMeasuresHandler(ids) {
  //       // console.log('    My MEASURES  work - DataMX recordSEle Handler: ', ids)
  //       // // console.log('                   BREAK >>  filter  this.myAssignedWorkItems                      XXX  by  id :')

  //       // const dTask = this.allMyMeasures.filter((items) => ids.includes(items.id))
  //       // // console.log('  *** TEST   myAssignedWorkItems/                        *******************allMyAssignedWork ************************************************ TEST TEST TEST  dTask: ', dTask)

  //       const tasks = this.allMyMeasures.filter(items => ids.includes(items.id)).map(included => ({
  //         type: props.type,
  //         description: included.messageSubject + ' : ' + included.taskType,
  //         id: included.id,
  //         sourceId: props.sourceId,
  //         containerId: parseInt(0),
  //       }))
  //       // console.log('           DASH-  DataMXn  :  recordsSelectedMeasuresHandler    ***     ***           DASH-   tasks', tasks)
  //       // // console.log(' Add DASH TaskRECORDS - - - - ASSIGNED ')

  //       this.addDashTaskRecords({ sourceId: props.sourceId, tasks })
  //     },
  // // lifecycle to setup and teardown side effects.
  onMounted(() => {})
  onUnmounted(() => {})
  // expose managed state as return value
  return { recordsSelectedWidgetWork, recordsSelectedWidgetOtherWork,currentlySelectedRecords, }
};



// ! org
// import { mapState, mapMutations, mapGetters } from 'vuex'

// export default function discreteDataDashMixin(props) {
//   return {
//     computed: {
//       ...mapState({
//         patientId: state => state.patient.currentPatientId,
//       }),
//       ...mapGetters([
//         'getDashTaskRecordsForSource',
//         'getAllDashTaskRecords',
//         'currentSelectedWorkSummaryWidget',
//       ]),
//       currentlySelectedRecords() {
//         // // console.log('   currentlySelectedRecords >>>> discreteDataDASH mixn     dDAPI:  props.sourceId: ', props.sourceId)

//         const taskRecSource = this.getDashTaskRecordsForSource(this.currentSelectedWorkSummaryWidget.sourceId).map(record => record.id)
//         // // console.log(' Get taskRecords by Source of :', props.sourceId)
//         // // console.log('      * ARRAY of IDs (selectedFromRow) *                 taskRecSource :', taskRecSource.length)
//         // // console.log('                                         SOURCE CHECK:  rtns  record.id=      taskRecSource :')
//         // // console.dir(taskRecSource)

//         return this.getDashTaskRecordsForSource(this.currentSelectedWorkSummaryWidget.sourceId).map(record => record.id)
//       },
//     },
//     methods: {
//       ...mapMutations(['addDashTaskRecords']),
//       recordsSelectedWidgetWork(ids) {
//         // // console.clear()
//         // console.log('    WIDGET Record - DataMX recordSEle Handler: ', ids)

//         // const dTask = this.allMyWork.filter((patient) => ids.includes(patient.personId))
//         // // console.log('   dTask: ', dTask)
//         // // console.log('  >>> PROPS from ROOT function  ')
//         // // console.log(props)

//         // let lSource = parseInt(this.currentSelectedWorkSummaryWidget.sourceId)

//         // &  task / delg tasks   containerId: parseInt(included.personId),
//         // & ELSE  task / delg tasks   containerId: parseInt(0),

//         // console.log(this.currentSelectedWorkSummaryWidget)
//         // console.log(this.currentSelectedWorkSummaryWidget.sourceId)
//         // console.log(this.currentSelectedWorkSummaryWidget.sourceType)

//         let sSourceId = 0
//         let sSourceType = 'XXXX'
//         // console.log(sSourceId + ' ' + sSourceType)

//         sSourceId = this.currentSelectedWorkSummaryWidget.sourceId
//         sSourceType = this.currentSelectedWorkSummaryWidget.sourceType
//         // console.log(sSourceId + ' ' + sSourceType)

//         const tasks = this.currentSelectedWorkSummaryWidget.widgetGridDataArray.filter(patient => ids.includes(patient.personId)).map(included => ({
//           type: sSourceType,
//           description: included.lastName + ' ' + included.firstName,
//           id: included.id,
//           sourceId: sSourceId,
//           containerId: parseInt(included.personId),
//         }))
//         // console.log('   ***     ***     recordsSelectedDashHandler     ***     recordsSelectedWidgetWork     ***           DASH-   tasks', tasks)
//         // console.log(' >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  ** TODO:  this.addDashTaskRecords({ ')

//         // console.log(sSourceId)
//         // console.dir(tasks)


//         this.addDashTaskRecords({ sourceId: sSourceId, tasks })
//       },
//        recordsSelectedWidgetOtherWork(ids) {
//         // // console.clear()
//         // console.log('    WIDGET Record - DataMX recordSEle Handler: ', ids)

//         // const dTask = this.allMyWork.filter((patient) => ids.includes(patient.personId))
//         // // console.log('   dTask: ', dTask)
//         // // console.log('  >>> PROPS from ROOT function  ')
//         // // console.log(props)

//         // let lSource = parseInt(this.currentSelectedWorkSummaryWidget.sourceId)

//         // &  task / delg tasks   containerId: parseInt(included.personId),
//         // & ELSE  task / delg tasks   containerId: parseInt(0),

//         // console.log(this.currentSelectedWorkSummaryWidget)
//         // console.log(this.currentSelectedWorkSummaryWidget.sourceId)
//         // console.log(this.currentSelectedWorkSummaryWidget.sourceType)

//         let sSourceId = 0
//         let sSourceType = 'XXXX'
//         // console.log(sSourceId + ' ' + sSourceType)

//         sSourceId = this.currentSelectedWorkSummaryWidget.sourceId
//         sSourceType = this.currentSelectedWorkSummaryWidget.sourceType
//         // console.log(sSourceId + ' ' + sSourceType)

//         const tasks = this.currentSelectedWorkSummaryWidget.widgetGridDataArray.filter(items => ids.includes(items.id)).map(included => ({
//           type: sSourceType,
//           description: included.messageSubject + ' : ' + included.taskType,
//           id: included.id,
//           sourceId: sSourceId,
//           containerId: parseInt(0),
//         }))

//         // console.log('   ***     ***     recordsSelectedDashHandler     ***     recordsSelectedWidgetWork     ***           DASH-   tasks', tasks)
//         // console.log(' >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  ** TODO:  this.addDashTaskRecords({ ')

//         // console.log(sSourceId)
//         // console.dir(tasks)


//         this.addDashTaskRecords({ sourceId: sSourceId, tasks })
//       },
//       recordsSelectedDashHandler(ids) {
//         // console.log('    DASH- DataMX recordSEle Handler: ', ids)

//         // const dTask = this.allMyWork.filter((patient) => ids.includes(patient.personId))
//         // // console.log('   dTask: ', dTask)

//         const tasks = this.allMyWork.filter(patient => ids.includes(patient.personId)).map(included => ({
//           type: props.type,
//           description: included.lastName + ' ' + included.firstName,
//           id: included.id,
//           sourceId: props.sourceId,
//           containerId: parseInt(included.personId),
//         }))
//         // console.log('   ***     ***     recordsSelectedDashHandler     ***     ***     ***           DASH-   tasks', tasks)
//         // // console.log('   ***     containerId: parseInt(inc.personId) ', tasks)
//         // // console.log('   ** TODO:  id=8||4248 string  >>>>>>>>>>>>>>>>>>>>>>>>  DASH-   tasks', tasks)

//         this.addDashTaskRecords({ sourceId: props.sourceId, tasks })
//       },
//       recordsSelectedDelegatedDashHandler(ids) {
//         // // console.log('    DASH- DataMX recordSEle Handler: ', ids)

//         // const dTask = this.allMyDelegatedWork.filter((patient) => ids.includes(patient.personId))
//         // // console.log('  CHECK DELEGATED = dTask: ', dTask)

//         const tasks = this.allMyDelegatedWork.filter(patient => ids.includes(patient.personId)).map(included => ({
//           type: props.type,
//           description: included.lastName + ' ' + included.firstName,
//           id: included.id,
//           sourceId: props.sourceId,
//           containerId: parseInt(included.personId),
//         }))
//         // console.log('   ***     ***      recordsSelectedDelegatedDashHandler     ***     ***     ***           DASH-   tasks', tasks)
//         // // console.log('   ***     containerId: parseInt(inc.personId) ', tasks)
//         // // console.log('   ** TODO:  id=8||4248 string  >>>>>>>>>>>>>>>>>>>>>>>>  DASH-   tasks', tasks)

//         this.addDashTaskRecords({ sourceId: props.sourceId, tasks })
//       },
//       recordsSelectedMyOtherHandler(ids) {
//         // // console.log('    MyOTHER  work - DataMX recordSEle Handler: ', ids)
//         // // console.log('BREAK >>  filter  this.myOtherWork XXX  by  id :')

//         // const dTask = this.allMyOtherWork.filter((items) => ids.includes(items.id))
//         // // console.log('  **********allMyOtherWork************************************************************  dTask: ', dTask)

//         const tasks = this.allMyOtherWork.filter(items => ids.includes(items.id)).map(included => ({
//           type: props.type,
//           description: included.messageSubject + ' : ' + included.taskType,
//           id: included.id,
//           sourceId: props.sourceId,
//           containerId: parseInt(0),
//         }))
//         // console.log('   ***     ***      recordsSelectedMyOtherHandler     ***     ***     ***           DASH-   tasks', tasks)
//         // console.log('   ***     containerId: parseInt( 0 ) ', tasks[0].containerId)

//         // console.log(' Add DASH TaskRECORDS')
//         this.addDashTaskRecords({ sourceId: props.sourceId, tasks })
//       },
//       recordsSelectedMyASSIGNEDHandler(ids) {
//         // // console.log('    My ASSIGNED  work - DataMX recordSEle Handler: ', ids)
//         // // console.log('                   BREAK >>  filter  this.myAssignedWorkItems                      XXX  by  id :')

//         // const dTask = this.allMyAssignedWork.filter((items) => ids.includes(items.id))
//         // // console.log('  *** TEST   myAssignedWorkItems/                        *******************allMyAssignedWork ************************************************ TEST TEST TEST  dTask: ', dTask)

//         const tasks = this.allMyAssignedWork.filter(items => ids.includes(items.id)).map(included => ({
//           type: props.type,
//           description: included.messageSubject + ' : ' + included.taskType,
//           id: included.id,
//           sourceId: props.sourceId,
//           containerId: parseInt(0),
//         }))
//         // console.log('           DASH-  DataMXn  :  recordsSelectedMyASSIGNEDHandler    ***     ***           DASH-   tasks', tasks)
//         // // console.log(' Add DASH TaskRECORDS - - - - ASSIGNED ')

//         this.addDashTaskRecords({ sourceId: props.sourceId, tasks })
//       },
//       recordsSelectedMeasuresHandler(ids) {
//         // console.log('    My MEASURES  work - DataMX recordSEle Handler: ', ids)
//         // // console.log('                   BREAK >>  filter  this.myAssignedWorkItems                      XXX  by  id :')

//         // const dTask = this.allMyMeasures.filter((items) => ids.includes(items.id))
//         // // console.log('  *** TEST   myAssignedWorkItems/                        *******************allMyAssignedWork ************************************************ TEST TEST TEST  dTask: ', dTask)

//         const tasks = this.allMyMeasures.filter(items => ids.includes(items.id)).map(included => ({
//           type: props.type,
//           description: included.messageSubject + ' : ' + included.taskType,
//           id: included.id,
//           sourceId: props.sourceId,
//           containerId: parseInt(0),
//         }))
//         // console.log('           DASH-  DataMXn  :  recordsSelectedMeasuresHandler    ***     ***           DASH-   tasks', tasks)
//         // // console.log(' Add DASH TaskRECORDS - - - - ASSIGNED ')

//         this.addDashTaskRecords({ sourceId: props.sourceId, tasks })
//       },
//     },
//   }
// }
